export const theme = {
  colours: {
    black: "#373737",
    white: "white",
    lightGrey: "#F8F8F8",
    blue: "#506bfb",
    orange: "#eb674c",
    yellow: "#e5bc0b",
    pink: "#f5b8ec",
    green: "#197b30",
    // Accessibility and forms
    focus: "blue",
    error: "#d0021b",
  },
  typography: {
    min: 14,
    max: 16,
    minScreen: 400,
    maxScreen: 2000,
    scale: {
      min: 1.125,
      max: 1.250,
    },
  },
  // https://www.smashingmagazine.com/2016/05/fluid-typography/
  fluidType: (exp) => {
    return `
      font-size: ${
        theme.typography.min * Math.pow(theme.typography.scale.min, exp)
      }px;
      @media screen and (min-width: ${theme.typography.minScreen}px ) {
        font-size: calc( ${
          theme.typography.min * Math.pow(theme.typography.scale.min, exp)
        }px + (${
      theme.typography.max * Math.pow(theme.typography.scale.max, exp)
    } - ${
      theme.typography.min * Math.pow(theme.typography.scale.min, exp)
    })*(100vw - ${theme.typography.minScreen}px)/(${
      theme.typography.maxScreen
    } - ${theme.typography.minScreen}) );
      }
      @media screen and (min-width: ${theme.typography.maxScreen}px ) {
        font-size: ${
          theme.typography.max * Math.pow(theme.typography.scale.max, exp)
        }px;
      }
      `
  },
  breakpoints: {
    sm: "min-width: 576px",
    md: "min-width: 768px",
    lg: "min-width: 992px",
    xl: `min-width: 1200px`,
  },
}
